import { endpoints } from 'modules/endpoints'
import { createBasicManagers } from 'modules/utils/helpers/createBasicManagers'
import { octopusApiClient } from 'modules/utils/httpClient'
import {
  TargetSkuListRequestFilter,
  TargetSkuListRequestSorting,
  FarmerTargetSku,
  FarmerTargetSkuCreateDTO,
  TargetSkuUpdateDTO,
} from '../common/types'
import { ListResponse } from 'types/api'

// export default createBasicManagers<
//   TargetSkuListRequestFilter,
//   TargetSkuListRequestSorting,
//   FarmerTargetSku,
//   FarmerTargetSkuCreateDTO,
//   TargetSkuUpdateDTO
// >(endpoints.farmerTargetSku, octopusApiClient)

const farmerTargetSkuManagers = {
  ...createBasicManagers<
    TargetSkuListRequestFilter,
    TargetSkuListRequestSorting,
    FarmerTargetSku,
    FarmerTargetSkuCreateDTO,
    TargetSkuUpdateDTO
  >(endpoints.farmerTargetSku, octopusApiClient),
  getList: (
    filter: TargetSkuListRequestFilter,
    sorting: TargetSkuListRequestSorting,
    page: number,
    pageSize?: number,
  ) => {
    try {
      return octopusApiClient.get<ListResponse<FarmerTargetSku>>(endpoints.farmerTargetSku(), {
        ...filter,
        ...sorting,
        page: page,
        page_size: pageSize,
        order_by: 'product_asc',
      })
    } catch (err) {
      console.error('List fetch error!', err)
      throw err
    }
  },
}

export default farmerTargetSkuManagers
